import {  Flex, Spinner } from "@chakra-ui/react";
import FileManagerContent from "./Content";
const FileManager = (props) => {

  if (!props.ContractData) {
    return (
      <Flex justify="center" align="center" h="200px">
        <Spinner />
      </Flex>
    );
  }
  return <FileManagerContent {...props}/>
};

export default FileManager;
